import React, { FC, Fragment } from 'react';
import { Table, TableBody, TableHead, TableCell } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { EmptyState, Loaders, ResponsiveTable } from 'components';
import { useNotify } from 'hooks';
import { useSharesItemsBySession } from 'features/activity/hooks';

import DateCell from './Cells/Date';
import ImageCell from './Cells/Image';
import ScheduledShareCell from './Cells/ScheduledShare';
import { RowHead, RowBody } from './TableRow';
import ListLoader from '../ListLoader';

const ScheduledShares: FC = () => {
  const notify = useNotify();
  const { t } = useTranslation();

  const variables = {
    scheduled: true,
    group_by_session: true,
    data: {
      limit: 10,
    },
  };

  const { results, isExhausted, isEmpty, isInitialLoad, sentinelRef } = useSharesItemsBySession(
    variables,
    {
      onError: notify.queryError,
    }
  );

  if (isInitialLoad) {
    return <ListLoader />;
  }

  if (isEmpty) {
    return <EmptyState name="scheduled" />;
  }

  return (
    <Fragment>
      <ResponsiveTable>
        <Table>
          <TableHead>
            <RowHead>
              <TableCell colSpan={4} size="small">
                {t('common:scheduled')}
              </TableCell>
            </RowHead>
          </TableHead>
          <TableBody>
            {results.map(shareItem => (
              <RowBody key={shareItem[0].id}>
                <DateCell time={shareItem[0].share_at} />
                <ImageCell content={shareItem[0].content} />
                <ScheduledShareCell items={shareItem} />
              </RowBody>
            ))}
          </TableBody>
        </Table>
      </ResponsiveTable>
      {!isExhausted && (
        <div ref={sentinelRef}>
          <Loaders.Standard />
        </div>
      )}
    </Fragment>
  );
};

export default ScheduledShares;
